import { defineMessages } from "react-intl";

const commonErrorMessages = defineMessages({
  graphqlError: {
    defaultMessage: "API error"
  },
  invalid: {
    defaultMessage: "Invalid value"
  },
  unknownError: {
    defaultMessage: "Unknown error"
  }
});

export default commonErrorMessages;
